module.exports = __webpack_public_path__ + "static/media/bn_synthesis2.708aeae5.png";